import { type ReactNode } from 'react';
import { COUNTRIES } from '@/utils/countries';
import { FieldInput, FieldSelect } from '@/components/ui/field-input';
import { type FieldProps, field } from './signup-field-helpers';

export function PhoneRow({ data, onChange, errors }: FieldProps): ReactNode {
  return (
    <div className="grid grid-cols-1 gap-sm sm:grid-cols-[120px_1fr]">
      <FieldSelect
        value={data.phone_prefix}
        onChange={(e) => onChange({ ...data, phone_prefix: e.target.value })}
        error={errors?.phone_prefix}
      >
        <option value="">Prefijo</option>
        {COUNTRIES.map((c) => (
          <option key={c.code} value={c.dialCode}>
            {c.dialCode} ({c.code})
          </option>
        ))}
      </FieldSelect>
      <FieldInput
        type="tel"
        placeholder="Número de teléfono"
        value={data.phone_number}
        onChange={field(data, onChange, 'phone_number')}
        error={errors?.phone_number}
      />
    </div>
  );
}

function CountryOptions(): ReactNode {
  return (
    <>
      <option value="">Seleccionar país</option>
      {COUNTRIES.map((c) => (
        <option key={c.code} value={c.code}>
          {c.name}
        </option>
      ))}
    </>
  );
}

export function LocationRow({ data, onChange, errors }: FieldProps): ReactNode {
  return (
    <>
      <FieldSelect
        value={data.country}
        onChange={(e) => onChange({ ...data, country: e.target.value })}
        error={errors?.country}
      >
        <CountryOptions />
      </FieldSelect>
      <FieldInput
        placeholder="Ciudad"
        value={data.city}
        onChange={field(data, onChange, 'city')}
        error={errors?.city}
      />
    </>
  );
}
